import { render, staticRenderFns } from "./BusinessBalanceView.vue?vue&type=template&id=f628598c&scoped=true&"
import script from "./BusinessBalanceView.vue?vue&type=script&lang=js&"
export * from "./BusinessBalanceView.vue?vue&type=script&lang=js&"
import style0 from "./BusinessBalanceView.vue?vue&type=style&index=0&id=f628598c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f628598c",
  null
  
)

export default component.exports